import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MarketmanagerSharedModule } from '../../shared';
import {
    MarketplaceService,
    MarketplacePopupService,
    MarketplaceComponent,
    MarketplaceDetailComponent,
    MarketplaceDialogComponent,
    MarketplacePopupComponent,
    MarketplaceDeletePopupComponent,
    MarketplaceDeleteDialogComponent,
    marketplaceRoute,
    marketplacePopupRoute,
    MarketplaceResolvePagingParams,
} from './';

const ENTITY_STATES = [
    ...marketplaceRoute,
    ...marketplacePopupRoute,
];

@NgModule({
    imports: [
        MarketmanagerSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        MarketplaceComponent,
        MarketplaceDetailComponent,
        MarketplaceDialogComponent,
        MarketplaceDeleteDialogComponent,
        MarketplacePopupComponent,
        MarketplaceDeletePopupComponent,
    ],
    entryComponents: [
        MarketplaceComponent,
        MarketplaceDialogComponent,
        MarketplacePopupComponent,
        MarketplaceDeleteDialogComponent,
        MarketplaceDeletePopupComponent,
    ],
    providers: [
        MarketplaceService,
        MarketplacePopupService,
        MarketplaceResolvePagingParams,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MarketmanagerMarketplaceModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketplace/marketplace.module.ts